"use strict";
import i from "./index.es144.js";
function a(c) {
  return i.matchAll(/\w+|\[(\w*)]/g, c).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function f(c) {
  const e = {}, o = Object.keys(c);
  let t;
  const r = o.length;
  let s;
  for (t = 0; t < r; t++)
    s = o[t], e[s] = c[s];
  return e;
}
function m(c) {
  function e(o, t, r, s) {
    let n = o[s++];
    if (n === "__proto__") return !0;
    const u = Number.isFinite(+n), l = s >= o.length;
    return n = !n && i.isArray(r) ? r.length : n, l ? (i.hasOwnProp(r, n) ? r[n] = [r[n], t] : r[n] = t, !u) : ((!r[n] || !i.isObject(r[n])) && (r[n] = []), e(o, t, r[n], s) && i.isArray(r[n]) && (r[n] = f(r[n])), !u);
  }
  if (i.isFormData(c) && i.isFunction(c.entries)) {
    const o = {};
    return i.forEachEntry(c, (t, r) => {
      e(a(t), r, o, 0);
    }), o;
  }
  return null;
}
export {
  m as default
};
//# sourceMappingURL=index.es149.js.map
